module.exports = __webpack_public_path__ + "static/media/picto-stand.6cb70897.svg";